import React, {
  useEffect,
  useState,
} from 'react';
import { observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import {
  ControlLabel,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import PropTypes from 'prop-types';

const ReasonCodeSelection = observer((props) => {
  const { onChange = () => {}, reasonCode = [], t } = props;
  const _reason = reasonCode.length ? reasonCode[0].id : '';
  const [ reason, setReason ] = useState(_reason);

  useEffect(() => {
    onChange(reason);
  }, [onChange, reason]);

  return(
    <FormGroup>
      <ControlLabel>{t('Reason code')}</ControlLabel>
      <FormControl
        name={'code'}
        componentClass="select"
        value={reason || ''}
        onChange={e => {
          setReason(e.target.value);
        }}
        bsSize="sm"
      >
        {reasonCode.map(option => (
          <option key={option.id} value={option.id}>
            {option.shortDescription} - {option.description}
          </option>
        ))}
      </FormControl>
    </FormGroup>
  );
});

ReasonCodeSelection.propTypes = {
  reasonCode: PropTypes.array,
  onChange: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(ReasonCodeSelection);
